import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkDisallowEditWhiteboard } from 'features/permissions/actions';

export function* bulkDisallowEditWhiteboardSaga(
  action: ReturnType<typeof bulkDisallowEditWhiteboard>
) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk disallowed edit whiteboard for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkDisallowEditWhiteboard',
    data: { roles },
  });
}
